import { useEffect, useState } from "react";

import LinearProgress from "@material-ui/core/LinearProgress";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";

import loanNotesConnect from "../../../services/loan/loanNotes/connector";
import Note from "../../note/Note";

import "../../note/notes.scss";

function LoanNotes({
  loanNotes,
  getLoanNotesById,
  createLoanNote,
  confirmNoteCreate,
  loanId,
}) {
  const [text, setText] = useState("");
  useEffect(() => {
    getLoanNotesById(loanId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const data = loanNotes[loanId];

  useEffect(() => {
    if (data && data.sent) {
      confirmNoteCreate(loanId);
      setText("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  if (!data || (data && data.fetching)) return <LinearProgress />;

  if (data.error) return <div>{data.error}</div>;

  return (
    <div>
      {data.data.map((note) => (
        <Note {...note} key={note.Id} />
      ))}

      <div className="create-note">
        <div>
          <TextField
            variant="outlined"
            label="New note"
            fullWidth
            multiline
            value={text}
            onChange={(e) => setText(e.target.value)}
          />
        </div>
        <Button
          disabled={data.sending || !text}
          onClick={() => createLoanNote(loanId, text)}
          variant="contained"
          color="primary"
        >
          Create note
        </Button>
        {data.sending && <LinearProgress />}
      </div>
    </div>
  );
}

function _LoanNotes(props) {
  return (
    <div>
      <h4>Loan Notes</h4>
      <LoanNotes {...props} />
    </div>
  );
}

export default loanNotesConnect(_LoanNotes);
